import { apiFetch, type AjaxResult } from './http';

export type AppLoginResult = {
  tokenType: string;
  accessToken: string;
  expiresIn: number;
  user: {
    userId: number;
    userName: string;
    email: string;
    memberLevelCode: string;
    memberLevelName: string;
    referralCode: string;
  };
};

export type AppProfile = {
  userId: number;
  userName: string;
  email: string;
  memberLevelId: number;
  memberLevelCode: string;
  memberLevelName: string;
  memberExpireTime: string | null;
  memberPermanent?: string;
  pointsBalance?: number;
  walletBalance?: number;
  freeSearchRemaining?: number;
  referralCode: string;
  registerIp: string;
  loginIp: string;
  registerTime: string;
  loginDate: string;
  status: string;
  /** 绑定的合作伙伴名称（无则为空） */
  partnerName?: string | null;
  /** Chatwoot setUser 用的 HMAC-SHA256 hex（后端签发） */
  chatwootIdentifierHash?: string;
};

export async function registerApi(body: {
  userName: string;
  email: string;
  password: string;
  inviteCode?: string;
  registerDomain?: string;
}): Promise<AjaxResult<unknown>> {
  return apiFetch('/api/app/auth/register', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export async function loginApi(account: string, password: string): Promise<AjaxResult<AppLoginResult>> {
  return apiFetch('/api/app/auth/login', {
    method: 'POST',
    body: JSON.stringify({ account, password }),
  });
}

export async function profileApi(): Promise<AjaxResult<AppProfile>> {
  return apiFetch('/api/app/auth/profile', { method: 'GET', auth: true });
}
